import React from 'react';
import styles from './NewHomePage.module.css';
import {PortfolioTheme} from './usePortfolioTheme';

type ThemeToggleProps = {
    theme: PortfolioTheme;
    label: string;
    onToggle: () => void;
};

function ThemeToggle({theme, label, onToggle}: ThemeToggleProps) {
    return (
        <button
            className={styles.themeToggle}
            type="button"
            data-theme={theme}
            aria-label={label}
            aria-pressed={theme === 'dark'}
            onClick={onToggle}
        >
            <span className={styles.themeToggleTrack} aria-hidden="true">
                <svg className={styles.sunIcon} viewBox="0 0 20 20" focusable="false">
                    <circle cx="10" cy="10" r="3.25"/>
                    <path d="M10 1.75v2M10 16.25v2M1.75 10h2M16.25 10h2M4.17 4.17l1.42 1.42M14.41 14.41l1.42 1.42M15.83 4.17l-1.42 1.42M5.59 14.41l-1.42 1.42"/>
                </svg>
                <svg className={styles.moonIcon} viewBox="0 0 20 20" focusable="false">
                    <path d="M16.35 12.87A7 7 0 0 1 7.13 3.65 7 7 0 1 0 16.35 12.87Z"/>
                </svg>
                <span className={styles.themeToggleThumb}/>
            </span>
        </button>
    );
}

export default ThemeToggle;
